import { TFunction } from 'i18next'

type GetChargingCardLabelProps = {
  rfid: string
  cardName: string | null
  t: TFunction
}

/**
 * Function to format charging card label.
 * In case charging card name is not set up, we display just the charging card rfid.
 * In case charging card name is set up, we display both charging card name and charging card rfid.
 */
export const getChargingCardLabel = ({ rfid, cardName, t }: GetChargingCardLabelProps): string => {
  const cardLabel = cardName
    ? t('emobility.chargingCards.charging-card-full-name', { cardName, rfid })
    : t('emobility.chargingCards.charging-card-rfid', { rfid })

  return cardLabel
}
